import * as React from 'react';
import defaultContextValues from './defaultContextValues';

export interface ErrorBoundaryProps {
  onError: ({
    error,
    reset,
  }: {
    error: any;
    reset: () => void;
  }) => React.ReactNode;
  children: React.ReactNode;
}

export interface ContextTypes {
  baseUrl: string;
  domainUrl: string;
  graphdataUrl: string;
  transactionsUrl: string;
  orderUrl: string;
  orderContractNotesUrl: string;
  orderTransactionUrl: string;
  fundTransactionUrl: string;
  orderSearchUrl: string;
  transactionSearchUrl: string;
  jawsUrl: string;
  ErrorBoundary: typeof React.Component;
  /**
   * @deprecated
   * Use useSuggest from @oms/components-suggest instead
   * */
  Suggest: (...args: any) => null;
}

export const Context = React.createContext<ContextTypes>(defaultContextValues);
const { Provider, Consumer } = Context;

const useComponentsContext = () => React.useContext(Context);

export { Provider, Consumer, defaultContextValues, useComponentsContext };
